(function () {
  var DESKTOP_BREAKPOINT = 960;
  var instances = new WeakMap();

  var isDesktop = function () {
    return window.matchMedia('(min-width: ' + DESKTOP_BREAKPOINT + 'px)').matches;
  };

  var getGap = function (section) {
    var gap = parseInt(section.dataset.gap, 10);

    if (!gap && gap !== 0) {
      gap = parseInt(
        window.getComputedStyle(section).getPropertyValue('--custom-cards-grid-gap'),
        10
      );
    }

    return gap >= 0 ? gap : 16;
  };

  var destroyCarousel = function (section) {
    var instance = instances.get(section);

    if (!instance) {
      return;
    }

    if (instance.mediaQuery && instance.onBreakpointChange) {
      if (instance.mediaQuery.removeEventListener) {
        instance.mediaQuery.removeEventListener('change', instance.onBreakpointChange);
      } else if (instance.mediaQuery.removeListener) {
        instance.mediaQuery.removeListener(instance.onBreakpointChange);
      }
    }

    if (instance.swiper && !instance.swiper.destroyed) {
      instance.swiper.destroy(true, true);
    }

    instances.delete(section);
  };

  var initSwiper = function (section) {
    var swiperEl = section.querySelector('.custom-cards-grid__grid');
    var paginationEl = section.querySelector('.custom-cards-grid__pagination');

    if (!swiperEl || !window.Swiper || swiperEl.swiper) {
      return null;
    }

    return new window.Swiper(swiperEl, {
      slidesPerView: 1.15,
      spaceBetween: getGap(section),
      speed: 500,
      watchOverflow: true,
      simulateTouch: true,
      grabCursor: true,
      preventClicks: true,
      preventClicksPropagation: true,
      a11y: {
        enabled: true,
      },
      pagination: paginationEl
        ? {
            el: paginationEl,
            type: 'bullets',
            clickable: true,
          }
        : undefined,
      on: {
        init: function () {
          section.querySelectorAll('.custom-cards-grid__background-image').forEach(function (img) {
            img.setAttribute('draggable', 'false');
          });
        },
      },
    });
  };

  var syncCarousel = function (section) {
    var instance = instances.get(section);
    var swiperEl = section.querySelector('.custom-cards-grid__grid');

    if (!swiperEl) {
      return;
    }

    if (isDesktop()) {
      if (instance && instance.swiper && !instance.swiper.destroyed) {
        instance.swiper.destroy(true, true);
        instance.swiper = null;
      }
      return;
    }

    if (!window.Swiper) {
      return;
    }

    if (!instance) {
      instance = {
        swiper: null,
        mediaQuery: null,
        onBreakpointChange: null,
      };
      instances.set(section, instance);
    }

    if (!instance.swiper || instance.swiper.destroyed) {
      instance.swiper = initSwiper(section);
    }
  };

  var initSection = function (section) {
    if (!section || instances.has(section)) {
      syncCarousel(section);
      return;
    }

    var mediaQuery = window.matchMedia('(min-width: ' + DESKTOP_BREAKPOINT + 'px)');
    var onBreakpointChange = function () {
      syncCarousel(section);
    };

    var instance = {
      swiper: null,
      mediaQuery: mediaQuery,
      onBreakpointChange: onBreakpointChange,
    };

    instances.set(section, instance);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', onBreakpointChange);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(onBreakpointChange);
    }

    syncCarousel(section);
  };

  var initSections = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-custom-cards-grid]').forEach(function (section) {
      initSection(section);
    });
  };

  var destroySections = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-custom-cards-grid]').forEach(function (section) {
      destroyCarousel(section);
    });
  };

  var bootstrap = function () {
    initSections();

    if (window.Swiper) {
      return;
    }

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;

      if (window.Swiper) {
        window.clearInterval(timer);
        initSections();
      } else if (attempts > 50) {
        window.clearInterval(timer);
      }
    }, 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSections(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroySections(event.target);
  });
})();
